import React from 'react';
import { journeySteps } from '../data/unstuckContent';
type JourneyStripProps = {
  className?: string;
};
export function JourneyStrip({
  className = ''
}: JourneyStripProps) {
  return <ol className={`flex flex-wrap items-center justify-center gap-x-3 gap-y-2 sm:gap-x-4 ${className}`} aria-label="The six stages of the UNSTUCK system, from dopamine to execution" data-id="element-130" data-mp="2ysmj2yg0zlht">
      {journeySteps.map((step, i) => <li key={step} className="flex items-center gap-3 sm:gap-4" data-id="element-131" data-mp="264qp41huc7oq" data-mpi={i}>
          <span className="text-[10px] font-semibold uppercase tracking-[0.2em] text-ivory-200 sm:text-[11px]" data-id="element-132" data-mp="215xb87yn6eo1">
            <span className="mr-1.5 font-sans text-champagne" data-id="element-133" data-mp="2f5y8ldfp73yr">{i + 1}</span>
            {step}
          </span>
          {i < journeySteps.length - 1 && <span className="text-champagne/40" aria-hidden="true" data-id="element-134" data-mp="3qk21shegoo2r">
              →
            </span>}
        </li>)}
    </ol>;
}